/*
 * @Author: Teemo Ding
 * @Date: 2021-09-02 09:26:11
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-16 11:16:38
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/GiftPurchase/GiftPurchaseEdit/Attributes/index.tsx
 */
import React from 'react';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import css from '../css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { Form } from 'src/components/Antd';
import AttributesTable from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/Attributes';
const Item = Form.Item;

const Attributes = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const { disableEdit } = props;
  // const { attributeName } = props;
  return (
    <SectionWrapper
      className={css.sectionContainer}
      title={getI18n('general.attributes')}
      subtitle={getI18n('salesChannelDirectDiscount.attribute.tip')}>
      <Item name={'attributes'}>
        <AttributesTable disableEdit={disableEdit} />
      </Item>
    </SectionWrapper>
  );
};

export default Attributes;
